class LocalStorage {
  public static AUTH_TOKEN: string;
  public static ROLE: string;
  public static USERNAME: string;
}
export default LocalStorage;
